import React from 'react';
import Checkbox from '@mui/material/Checkbox';

interface IData {
    [key: string]: any;
}

const ExactMatch: React.FC<IData> = (props) =>{
    return (
        <div className="custom-group-header" >
            <span>Exact Matches</span>
            <Checkbox size="small" inputRef={props.exactRef} sx={{ padding:0 }}/>
        </div>
    );
};

export default ExactMatch;